import * as Actions from './actions.js'

const initial = {
  settings: {
    loading: false,
    error: false,
    settings: {}
  }
}

export default function reducer (state = initial, action) {
  switch (action.type) {
    case 'admin/settings/loading':
      return {
        ...state,
        settings: {
          loading: true,
          error: false,
          settings: {}
        }
      }
    case 'admin/settings/loaded':
      return {
        ...state,
        settings: {
          error: false,
          loading: false,
          settings: action.settings
        }
      }
    case 'admin/settings/error':
      return {
        ...state,
        settings: {
          loading: false,
          error: action.error,
          settings: {}
        }
      }
    case 'admin/log/clients/loading':
      return {
        ...state,
        log: {
          ...state.log,
          clients: {
            loading: true
          }
        }
      }
    case 'admin/log/clients/loaded':
      return {
        ...state,
        log: {
          ...state.log,
          clients: {
            data: action.data
          }
        }
      }
    case 'admin/log/clients/error':
      return {
        ...state,
        log: {
          ...state.log,
          clients: {
            error: action.error
          }
        }
      }
    case 'admin/log/users/loading':
      return {
        ...state,
        log: {
          ...state.log,
          users: {
            loading: true
          }
        }
      }
    case 'admin/log/users/loaded':
      return {
        ...state,
        log: {
          ...state.log,
          users: {
            data: action.data
          }
        }
      }
    case 'admin/log/users/error':
      return {
        ...state,
        log: {
          ...state.log,
          users: {
            error: action.error
          }
        }
      }
    case 'admin/log/records/loading':
      return {
        ...state,
        log: {
          ...state.log,
          records: {
            loading: true
          }
        }
      }
    case 'admin/log/records/loaded':
      return {
        ...state,
        log: {
          ...state.log,
          records: {
            data: action.data,
            paging: action.paging,
            sort: action.sort,
            filter: action.filter
          }
        }
      }
    case 'admin/log/records/error':
      return {
        ...state,
        log: {
          ...state.log,
          records: {
            error: action.error
          }
        }
      }
    case 'admin/admin_record_patterns/loading':
      return {
        ...state,
        admin_record_patterns: {
          loading: true,
          filter: action.filter
        }
      }
    case 'admin/admin_record_patterns/loaded':
      return {
        ...state,
        admin_record_patterns: {
          data: action.data,
          paging: action.paging,
          sort: action.sort,
          filter: action.filter
        }
      }
    case 'admin/admin_record_patterns/error':
      return {
        ...state,
        admin_records: {
          error: action.error
        }
      }
    case 'admin/igao/loading':
      return {
        ...state,
        igao: {
          loading: true,
          filter: action.filter
        }
      }
    case 'admin/igao/loaded':
      return {
        ...state,
        igao: {
          data: action.data,
          paging: action.paging,
          sort: action.sort,
          filter: action.filter
        }
      }
    case 'admin/igao/error':
      return {
        ...state,
        igao: {
          error: action.error
        }
      }
    case Actions.EXTERNAL_RECEIVERS_SUCCESS:
      return {
        ...state,
        externalReceivers: action.results
      }
    case Actions.EXTERNAL_RECEIVERS_FAILURE:
      return {
        ...state,
        externalReceivers: [],
        loading: false,
        error: true
      }
    case Actions.ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        organizations: action.results
      }
    case Actions.ORGANIZATIONS_FAILURE:
      return {
        ...state,
        organizations: [],
        loading: false,
        error: true
      }
    case Actions.CONFIG_SUCCESS:
      return {
        ...state,
        configuration: action.results
      }
    case Actions.CONFIG_FAILURE:
      return {
        ...state,
        configuration: [],
        loading: false,
        error: true
      }
    case 'admin/status/loading':
      return {
        ...state,
        status: {
          loading: true,
          error: false,
          status: {}
        }
      }
    case 'admin/status/loaded':
      return {
        ...state,
        status: {
          error: false,
          loading: false,
          status: action.status
        }
      }
    case 'admin/status/error':
      return {
        ...state,
        status: {
          loading: false,
          error: action.error,
          status: {}
        }
      }
    default:
      return state
  }
}
